import messages_en from './en'
import messages_pl from './pl'

const messages = {
  en: messages_en,
  pl: messages_pl,
}

export default messages
